package crashreporting

interface CrashReporterLogger {
    fun d(message: String)
    fun e(message: String, error: Throwable? = null)

    companion object {
        val None: CrashReporterLogger = object : CrashReporterLogger {
            override fun d(message: String) = Unit
            override fun e(message: String, error: Throwable?) = Unit
        }

        val Println: CrashReporterLogger = object : CrashReporterLogger {
            override fun d(message: String) = println("[crashreporting] $message")
            override fun e(message: String, error: Throwable?) {
                println("[crashreporting] ERROR $message")
                error?.printStackTrace()
            }
        }
    }
}
